import React, { Fragment } from "react";
import Field from "../Field";
import TextFieldStyles from "../Input/TextField/TextField.module.css";
import { labelName } from "../../utils";

export default function FieldGroup({ ...props }) {
  const { field_items, field_label, field_type } = props;

  return (
    <div className="field-group">
      <h3 className={TextFieldStyles.fieldGroupTitle}>{labelName(field_label)}</h3>
      <div className="field-group-list">
        {field_items &&
          field_items.map((field, index) => (
            <Fragment key={`fied${index}`}>
              <Field field={field} parent={field_type} />
            </Fragment>
          ))}
      </div>
    </div>
  );
}
